export default "__VITE_PUBLIC_ASSET__769b7106__"